import ServicePageTemplate from '../services/ServicePageTemplate';
import { servicePageData } from '../../mocks/servicePages';
const InsulationPage = () => <ServicePageTemplate data={servicePageData['insulation']} />;
export default InsulationPage;
